<template>
  <section class="lender-page">
    <div class="lender-page_tabs">
      <button
        class="lender-page_tab"
        v-for="tab in tabs"
        :key="tab.label"
        :class="['tab-button', { active: isActive(tab) }]"
        @click="activeTab = tab"
      >
        {{ tab.label }}
      </button>
    </div>
    <LenderHeader></LenderHeader>
    <div class="lender-page_tabView">
      <!-- Only render the component if it's not null -->
      <component :is="activeTab.component" v-if="activeTab.component" />
    </div>
  </section>
</template>

<script>
import StudentApplications from "./tabs/StudentApplications.vue";
import AllStudents from "./tabs/AllStudents.vue"; // Import the new AllStudents component
import LenderHeader from "./LenderHeader.vue";

export default {
  components: {
    StudentApplications,
    AllStudents,
    LenderHeader
  },
  data() {
    return {
      tabs: [
        {
          label: "All Students",
          component: AllStudents, // Set AllStudents component here
        },
        {
          label: "Student Applications",
          component: StudentApplications,
        },
      ],
      activeTab: null,
    };
  },
  computed: {
    isActive() {
      return (tab) => this.activeTab && this.activeTab.label === tab.label;
    },
  },
  created() {
    this.activeTab = this.tabs[0]; // Set "All Students" as the default active tab
  },
};
</script>

<style lang="scss" scoped>
.lender-page {
  padding: 50px;
  max-width: 1400px;
  display: grid;
  gap: 50px;
  flex-direction: column;

  &_tabs {
    button {
      color: #404040;
      text-align: center;
      font-family: Helvetica;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      background: none;
      border-radius: 0;
      border-bottom: 2px solid rgba(64, 64, 64, 0.25);
      transition: none;
      padding-bottom: 15px;

      &.active {
        border-bottom: 2px solid #3C78FF;
      }
    }
  }
}
</style>
